import { render, staticRenderFns } from "./DealerSettings.vue?vue&type=template&id=7483d5d8&scoped=true&"
import script from "./DealerSettings.vue?vue&type=script&lang=js&"
export * from "./DealerSettings.vue?vue&type=script&lang=js&"
import style0 from "./DealerSettings.vue?vue&type=style&index=0&id=7483d5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7483d5d8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/DealerSettings.vue
// module id = null
// module chunks = 